function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

/** Base URL of the authenticated GWT app (separate React application). */
export function getAppUrl(): string {
  const raw = process.env.NEXT_PUBLIC_APP_URL?.trim() ?? ''
  return raw ? trimTrailingSlash(raw) : ''
}

export function getAppLoginUrl(): string {
  const base = getAppUrl()
  if (!base) return '/auth/login'
  return `${base}/auth/login`
}

export function getAppRegisterUrl(): string {
  const base = getAppUrl()
  if (!base) return '/auth/register'
  return `${base}/auth/register`
}
